// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const ModalAbort = require('components/commons/modalAbort/modalAbort');

// @ components
const { MortgageRequestInsurancesRelatedModal } = require('./mortgageRequestInsurancesRelatedModal');
const MortgageBonuses = require('./mortgageBonuses/mortgageBonuses');

// @ constants
const {
    DISCOUNTED_MORTGAGE,
    MORTGAGE_CANCEL_OPTION,
} = require('constants/flagBasedFeatures');
const INSURANCES_RELATED = '/myprofile/mortgage/insurances-related';
const { MORTGAGE_INSURANCE_BONUS_CLICK } = require('constants/tagging');
const { ACTION_EVENTS, BONUSES_KEY, TAGGING_LABEL_EVENTS } = require('constants/mortgageInsuranceBonuses');

// @utilities
const { recordLinkV2 } = require("utilities/tagging");

class MortgageBuildInsuranceRelatedPanelOption extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            confirmDeleteInsurance: false,
        };

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleHasNotInsuranceClick = this.handleHasNotInsuranceClick.bind(this);
        this.insuranceRelatedModal = this.insuranceRelatedModal.bind(this);
        this.handleToggleInsuranceCancelModal = this.handleToggleInsuranceCancelModal.bind(this);
        this.handleConfirmDeleteInsurance = this.handleConfirmDeleteInsurance.bind(this);
        this.recordTaggingEvent = this.recordTaggingEvent.bind(this);
        this.handleSaveMortgageWithInsuranceCondition = this.handleSaveMortgageWithInsuranceCondition.bind(this);
    }

    recordTaggingEvent(eventTag) {
        const customData = ({
            categoriaEvento: MORTGAGE_INSURANCE_BONUS_CLICK,
            accionEvento: ACTION_EVENTS[BONUSES_KEY.homeInsurance],
            etiquetaEvento: eventTag,
        });
        recordLinkV2(customData);
    }

    handleToggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    handleToggleInsuranceCancelModal() {
        this.setState({ confirmDeleteInsurance: !this.state.confirmDeleteInsurance });
        this.recordTaggingEvent(TAGGING_LABEL_EVENTS['CANCEL_BUTTON']);
    }

    handleConfirmDeleteInsurance() {
        const {
            history,
            mortgageInsurancesCancel,
            mortgageInsurancesLink,
        } = this.props;
        mortgageInsurancesLink(false, false);
        mortgageInsurancesCancel(false, history);
    }

    createPanelPoeditorKey(term) {
        const poeditorContext = __CONTACT_CENTER__ ? 'mortgageRequestPanelCC' : 'mortgageRequestPanel';
        return `${poeditorContext}-${poeditorContext}_${term}`;
    }

    buildInsuranceCancelModal() {
        return (
            <ModalAbort
                titleKey={this.createPanelPoeditorKey('insuranceCancelModalTitle')}
                textKey={this.createPanelPoeditorKey('InsuranceCancelModalBody')}
                isOpen={this.state.confirmDeleteInsurance}
                onAccept={this.handleConfirmDeleteInsurance}
                onCancel={this.handleToggleInsuranceCancelModal}
            />
        );
    }

    buildInsuranceCancelModallink() {
        const cancelInsuranceButtonKey = this.createPanelPoeditorKey('cancelInsuranceButton');
        return (
            <div className="col-xs-5">
                <div className="mortgage-cancel">
                    <OKLink
                        onClick={this.handleToggleInsuranceCancelModal}
                        modifier="dark"
                    >
                        <FormattedText value={cancelInsuranceButtonKey} />
                    </OKLink>
                </div>
            </div>
        )
    }

    buildOldMortgageOption(mortgageCancelOption) {
        const { insuranceStateData, accountHolder } = this.props;
        const textLinkClass = classNames('col-xs-7', {
            'text-right': mortgageCancelOption
        });
        const cancelInsuranceButton = mortgageCancelOption ? this.buildInsuranceCancelModallink() : null;
        const showForSecondHolder = accountHolder === 1 || (accountHolder !== 1 && insuranceStateData !== null)

        if (showForSecondHolder) {
            return (
                <li>
                    <div className="row">
                        <OKLink to="/myprofile/mortgage/insurances-related" modifier="emphasize">
                            <i
                                className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente mortgage-request-manager-panel-steps__ico--red"
                            />
                        </OKLink>
                        {cancelInsuranceButton}
                        <div className={textLinkClass}>
                            <OKLink
                                onClick={() => this.recordTaggingEvent(TAGGING_LABEL_EVENTS['HOME_INSURANCE'])}
                                to="/myprofile/mortgage/insurances-related"
                                modifier="emphasize"
                            >
                                <FormattedText value="mortgageRequestPanel-insuranceHomeOpen" />
                            </OKLink>
                        </div>
                    </div>
                </li>
            )
        }
    }

    buildMortgageHasInsurance() {
        const {
            hasInsurance,
            accountHolder,
            isBonusAvaiable,
            flagBasedFeatures,
            isInsuranceRestricted,
            mortgageInsuranceState,
            insuranceStateData,
            disclaimerMessage,
            subTypeDocument,
        } = this.props;
        const mortgageInsuranceStatus = mortgageInsuranceState.getIn(['insurancesRelatedStatusData', 'closedPrice']);
        const contractedMessage = <FormattedText value="mortgageRequestPanel-insurancesRelatedClosedPriceMessage" className="mortgage-request-manager-panel-steps__closed-price" />;
        const showContractedMessage = mortgageInsuranceStatus ? contractedMessage : null;
        const mortgageCancelOption = !isInsuranceRestricted && flagBasedFeatures.get(MORTGAGE_CANCEL_OPTION);
        const insuranceCancelModal = mortgageCancelOption ? this.buildInsuranceCancelModal() : null;

        return (
            <div>
                <ul className="list-unstyled mortgage-request-manager-panel-steps__list">
                    {isBonusAvaiable ?
                        <MortgageBonuses
                            isInsuranceRestricted={isInsuranceRestricted}
                            insuranceState={insuranceStateData}
                            subTypeDocument={subTypeDocument}
                            accountHolder={accountHolder}
                            mortgageInsuranceState={mortgageInsuranceState}
                            onHandleHasNotInsuranceClick={this.handleHasNotInsuranceClick}
                            hasInsurance={hasInsurance}
                            flagBasedFeatures={flagBasedFeatures}
                            mortgageCancelOption={mortgageCancelOption}
                            disclaimerMessage={disclaimerMessage}
                            onHandleToggleInsuranceCancelModal={this.handleToggleInsuranceCancelModal}
                        /> : this.buildOldMortgageOption(mortgageCancelOption)
                    }
                </ul>
                {showContractedMessage}
                {insuranceCancelModal}
            </div>
        );
    }

    handleSaveMortgageWithInsuranceCondition() {
        this.props.history.push(INSURANCES_RELATED);
    }

    insuranceRelatedModal() {
        const { flagBasedFeatures } = this.props;
        return this.state.showModal
            ? <MortgageRequestInsurancesRelatedModal
                flagBasedFeatures={flagBasedFeatures}
                onHandleSaveMortgageWithInsuranceCondition={this.handleSaveMortgageWithInsuranceCondition}
                onHandleToggleModal={this.handleToggleModal}
                showModal={this.state.showModal}
            />
            : null
    }

    handleHasNotInsuranceClick() {
        const { flagBasedFeatures } = this.props;
        const discountedMortgage = flagBasedFeatures.get(DISCOUNTED_MORTGAGE);
        return !!discountedMortgage ? this.handleSaveMortgageWithInsuranceCondition() : this.handleToggleModal();
    }

    buildMortgageHasNotInsurance() {
        return (
            <div className="mortgage-request-manager-panel-steps__insurances">
                <div className="col-xs-3 mortgage-request-manager-panel-steps__insurances-panel-image"></div>
                <div className="col-xs-9 mortgage-request-manager-panel-steps__insurances-description">
                    <span className="mortgage-request-manager-panel-steps__insurances-description-title">
                        <FormattedText value="mortgageRequestPanel-notInsuranceRelatedOptionTitle" />
                    </span>

                    <span className="mortgage-request-manager-panel-steps__insurances-description-message">
                        <FormattedText value="mortgageRequestPanel-notInsuranceRelatedOptionDescription" />
                    </span>

                    <div>
                        <OKLink
                            modifier="editorial"
                            onClick={this.handleHasNotInsuranceClick}
                        >
                            <FormattedText value="common-moreInformation" />
                        </OKLink>
                    </div>

                    {this.insuranceRelatedModal()}
                </div>
            </div>
        );
    }

    buildSpecialAppliesMessage() {
        const { history, mortgageInsurancesCancel } = this.props;
        return (
            <div className="mortgage-request-manager-panel-steps__insurances">
                <div className="col-xs-3 mortgage-request-manager-panel-steps__insurances-panel-image mortgage-request-manager-panel-steps__insurances-panel-image-operator"></div>
                <div className="col-xs-9 mortgage-request-manager-panel-steps__insurances-description">

                    <span className="mortgage-request-manager-panel-steps__insurances-description-message">
                        <FormattedText value="mortgageRequestPanelCC-mortgageRequestPanelCC_specialAppliesRequestInProgress" />
                    </span>

                    <div>
                        <OKLink
                            modifier="editorial"
                            onClick={() => mortgageInsurancesCancel(true, history)}
                        >
                            <FormattedText value="mortgageRequestPanelCC-mortgageRequestPanelCC_specialAppliesStartNewRequest" />
                        </OKLink>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            hasInsurance,
            showSpecialAppliesMessage,
            accountHolder,
            isFetching,
            isBonusAvaiable,
        } = this.props;
        let optionElement = null;

        if (showSpecialAppliesMessage) {
            optionElement = this.buildSpecialAppliesMessage();
        } else if (!hasInsurance && accountHolder === 1 && !isBonusAvaiable && !isFetching) {
            optionElement = this.buildMortgageHasNotInsurance();
        } else {
            optionElement = this.buildMortgageHasInsurance();
        }

        return optionElement;
    }
}

MortgageBuildInsuranceRelatedPanelOption.propTypes = {
    isBonusAvaiable: PropTypes.bool.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    hasInsurance: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    accountHolder:PropTypes.string.isRequired,
    disclaimerMessage: PropTypes.node.isRequired,
    insuranceStateData: PropTypes.object.isRequired,
    mortgageInsuranceState: PropTypes.object.isRequired,
    mortgageInsurancesCancel: PropTypes.func.isRequired,
    mortgageInsurancesLink: PropTypes.func.isRequired,
    showSpecialAppliesMessage: PropTypes.bool.isRequired,
    isInsuranceRestricted: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    subTypeDocument:PropTypes.string,
};

MortgageBuildInsuranceRelatedPanelOption.defaultProps = {
    showSpecialAppliesMessage: false,
}

module.exports = withRouter(MortgageBuildInsuranceRelatedPanelOption);
